import Api from './Api'
export default {
    getTypes() {
        return Api().get('/document/docLibraryTypes')
    },
    getDocuments(obj) {
        if (obj) {
            const { typeID, search, dateF, dateT, limit, page } = obj;

            let str = '';
            if (dateF) {
                str += 'date_from=' + dateF + '&';
            }
            if (dateT) {
                str += 'date_to=' + dateT + '&';
            }
            if (search) {
                str += 'search=' + search + '&';
            }
            if (typeID) {
                str += 'type_id=' + typeID + '&';
            }
            if (limit) {
                str += 'limit=' + limit + '&';
            }
            if (page) {
                str += 'page=' + page + '&';
            }

            return Api().get('/document/docLibraries?' + str)
        } else {
            return Api().get('/document/docLibraries')
        }
    },
    getDocument(id) {
        return Api().get('/document/link/' + id)
    },
    getDocumentsTypes() {
        return Api().get('/document/docLibraryTypes')
    }
}